export const MACRO_MGR_BASE_CLASSNAME = 'macro-manager'
